/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：1045
 */

"use strict"

var r = require(/* 21 */"../21")
var i = require(/* 0 */"react")
var o = {
  icon: {
    tag: "svg",
    attrs: {
      viewBox: "64 64 896 896",
      focusable: "false"
    },
    children: [
      {
        tag: "path",
        attrs: {
          d: "M699 353h-46.9c-10.2 0-19.9 4.9-25.9 13.3L469 584.3l-71.2-98.8c-6-8.3-15.6-13.3-25.9-13.3H325c-6.5 0-10.3 7.4-6.5 12.7l124.6 172.8a31.8 31.8 0 0051.7 0l210.6-292c3.9-5.3.1-12.7-6.4-12.7z"
        }
      }, {
        tag: "path",
        attrs: {
          d: "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z"
        }
      }
    ]
  },
  name: "check-circle",
  theme: "outlined"
}
var a = require(/* 224 */"../224/index")
var s = function (e, t) {
  return i.createElement(a.a, r.a(r.a({}, e), {}, {
    ref: t,
    icon: o
  }))
}
s.displayName = "CheckCircleOutlined"
exports.a = i.forwardRef(s)
